export enum BillingType {
  RENTAL = 'rental',
  BILLING = 'billing',
}
